export class Localizacao {
  cD_BPM_NR_UNIDADE!:number;

  dS_BPM_UNIDADE!:	string
  
  dS_BPM_UF_UNIDADE!:	string
  
  dS_BPM_MUNICIPIO_UNIDADE!:	string
  
  dS_BPM_ENDERECO_UNIDADE!:	string
  
  fL_BPM_ATIVO!:number;

  fL_BPM_DELETADO!:number;
  
}

export interface uf{
  id:number;
  nome:string;
  regiao:{};
  sigla:any;
}